import { NotificationManager } from "../../components/common/react-notifications";
import CustomPreviewWhatsApp from "../../components/utils/CustomPreviewWhatsApp";

export default (context) => {
  const M = "admLocalization."
  
  
  const changeTemplate = (ctx) => {
    // Find the template by ID in the stored data
    const selectedItem = ctx.state.templateId;
    
    if (selectedItem && selectedItem.body) {
      try {
        // Mock the tagsContent structure for preview functionality
        const mockTagsContent = []
        let content = selectedItem.body
        
        // Add header.image if template has an image URL
        if (selectedItem.img) {
          const imageUrl = selectedItem.img
          mockTagsContent.push({
            id: 'header.image',
            defValue: imageUrl
          })
          // Set the image URL in form state so preview can access it
          ctx.setState({ 'header.image': imageUrl })
        }
        
        // Extract placeholders from content ({{1}}, {{2}}, etc.)
        const placeholderMatches = content.match(/\{\{\d+\}\}/g) || []
        placeholderMatches.forEach((match, index) => {
          const placeholderNum = match.replace(/[{}]/g, '')
          mockTagsContent.push({
            id: `placeholder_${placeholderNum}`,
            defValue: `Lorem ipsum ${placeholderNum}`
          })
        })

        // Mock button placeholders if template has buttons
        /* if (templateData.buttons || templateData.template?.buttons) {
          const buttons = templateData.buttons || templateData.template.buttons || []
          buttons.forEach((button, index) => {
            mockTagsContent.push({
              id: `button_${index + 1}`,
              defValue: button.text || `Button ${index + 1}`
            })
          })
        }
          */
        
        const selectedTemplate = {
          content: content,
          tagsContent: mockTagsContent
        }
        
        // Set selectedTemplate, content, ID, and name fields
        ctx.setState({ 
          selectedTemplate,
          contentMD: content,
          ID: `${selectedItem.name}-${selectedItem.language}`,
          name: selectedItem.name,
          templateId:   {
              value: selectedItem.name,
              label: selectedItem.name,
              name: selectedItem.name,
              body: content,
              language: selectedItem.language,
              headerFormat: selectedItem.headerFormat,
              img: selectedItem.img || null
          }
        })
      } catch (error) {
        console.error('Error parsing template body:', error)
        NotificationManager.error('Error parsing template data', "Error", 5000, null, null, 'outline')
      }
    }
  }
  return {
    config: {
      pageSize: 40,
      list: true,  // Add this line to enable list view
      customPathGet: "admLocalization/get",
    },

    actions: {
      create: {
        reloadGrid: true
      },
      edit: true,
      delete: true,
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          // When editing, parse the ID to extract template name and set templateId dropdown
          if (r.data.ID && r.data.type === "w") {
            const lastDashIndex = r.data.ID.lastIndexOf('-');
            if (lastDashIndex > -1) {
              const templateName = r.data.ID.substring(0, lastDashIndex);
              const language = r.data.ID.substring(lastDashIndex + 1);

              r.data = {
                ...r.data,
                contentMD: r.data.content,
                templateId: {
                  value: templateName,
                  label: templateName,
                  name: templateName,
                  body: r.data.content,
                  language: language,
                  headerFormat: r.data.headerFormat || null,
                  img: r.data.img || null
                }
              };
            }
          }
          
          // Map content to the appropriate field based on type
          if (r.data.type === "m") {
            r.data.contentHTML = r.data.content;
          } else if (r.data.type === "w" && !r.data.contentMD) {
            r.data.contentMD = r.data.content;
          }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        // Extract templateId value
        v.templateId = v.templateId?.value ?? v.templateId
        
        // Map the active content field to 'content' based on type
        if (v.type === "m" && v.contentHTML !== undefined) {
          // For email type, use contentHTML as content
          v.content = v.contentHTML;
        } else if (v.type === "w" && v.contentMD !== undefined) {
          // For WhatsApp type, use contentMD as content
          v.content = v.contentMD;
        } else if (v.content === undefined || v.content === null) {
          // If content is undefined or null, set it to empty string
          v.content = "";
        }
        
        // Extract tagsContent from selectedTemplate to root level
        if (v.selectedTemplate?.tagsContent) {
          v.tagsContent = v.selectedTemplate.tagsContent;
        }
        
        return v;
      },
      fields: [
        {
          col: 6,
          name: "type",
          value: "w",
          type: "select",
          label: `${M}templateType`,
          rules: "required",
          opts: {
            style: 'float-label',
            items: [
              {
                value: "w",
                label: "WhatsApp"
              },
              {
                value: "m",
                label: "Email"
              }
            ]
          },
          onChange: (ctx) => {
            ctx.setState({
              templateId: null,
              selectedTemplate: null
            })
          }
        },
        {
          col: 6,
          name: "templateId",
          value: "",
          type: "select",
          label: `${M}baseTemplate`,
          opts: {
            style: 'float-label',
            path: `/admLocalization/getMeta`,
            setOutput: v => { 
              if (v) {
                if(v.original){
                  return {
                    value: v.original.name+"-"+v.original.language,
                    label: v.label, 
                    name: v.original.name,
                    body: v.original.body,
                    language: v.original.language,
                    headerFormat: v.original.headerFormat || v.original.header_format || null,
                    img: v.original.img || null
                  }
                } else return v
              }
            },
            addon: {
              append: {
                buttons: [
                  {
                    disabled: ctxField => !ctxField.state.templateId,
                    name: "main.preview",
                    onClick: () => context.togglePreview()
                  }
                ]
              }
            }
          },
          onChange: (ctx) => {
            if (!ctx.state.templateId) {
              ctx.setState({selectedTemplate: null})
              return
            }
            changeTemplate(ctx)
          },
          disabled: () => context.state.idItemSelected ? true : false,
          renderIf: (ctx) => ctx.state.type === "w"
        },
        {
          col: 6,
          name: "ID",
          rules: "required|max:32|alpha_num_dash",
          value: "",
          type: "text",
          label: `${M}uniqueCodeOfTheText`,
          opts: {
            style: 'float-label'
          },
          disabled: (ctx) => { return context.state.idItemSelected || ctx.state.type === "w" ? true : false }
        },
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          rules: "required|max:100",
          label: `${M}descriptionName`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "contentHTML",
          value: "",
          type: "editor",
          label: `${M}emailContent`,
          renderIf: (ctx) => ctx.state.type === "m"
        },
        {
          col: 12,
          name: "contentMD",
          value: "",
          type: "textarea",
          label: `${M}whatsappContent`,
          renderIf: (ctx) => ctx.state.type === "w",
          disabled: () => { return true }
        },
        {
          col: 12,
          name: "printParams",
          value: "",
          type: "textarea",
          label: `${M}advancedParameters`,
        }
      ]
    },

    columns: [
      {
        Header: "main.name", 
        accessor: "name",
        minWidth: 120
      },
      {
        Header: "main.ID",
        accessor: "ID",
      },
      {
        Header: "main.desc",
        accessor: "desc",
      }
    ],

    preview: {
      template: CustomPreviewWhatsApp,
      previewOf: {
        form: {
          name: `main.whatsappMessagePreview`,
          handleData: (data) => {
            if (!data || !data.selectedTemplate) return []
            
            let msgs = []
            let header = data.selectedTemplate.content
            let buttons = []
            let headerImage = null
            const tagsContent = data.selectedTemplate.tagsContent
            if (tagsContent) {
             
              tagsContent.forEach((t, index) => {
                  // Extract the placeholder number from the ID (e.g., "placeholder_1" -> "1")
                  const placeholderNum = t.id.replace('placeholder_', '')
                  header = header.replaceAll(`{{${placeholderNum}}}`, t.defValue)
                if (t.id.includes("button")) {
                  buttons.push(t)
                }
                // Check for header image
                if (t.id === "header.image") {
                  headerImage = data[t.id] || t.defValue
                }
              })
            }
            
            const m = {
              type: "received",
              content: header,
              buttons: buttons,
              media: headerImage
            }
            msgs.push(m)
            
            return msgs
          }
        }
      },
      renderIf: () => context.state.form?.selectedTemplate && context.state.form?.type === "w"
    }
  }
}